<template>
    <div class="heating-system-warning-warp">
        <monitorTitle nub="4" text="加热系统预警" width="auto" />

        <div class="box">
            <div class="nav">
                <div class="nav-item" :class="{'active':navActive===i.id}" v-for="(i,k) in navList" :key="k"
                    @click="clickNavItem(i)">{{i.name}}
                </div>
            </div>
            <div class="list-warp" :style="style">
                <div class="item">
                    <heatingTubeOvertemperature />
                </div>
                <div class="item">
                    <heatingRelay />
                </div>
                <div class="item">
                    <systemEarlyWarning />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import heatingTubeOvertemperature from './heating-tube-overtemperature.vue'
  import heatingRelay from './heating-relay.vue'
  import systemEarlyWarning from './system-early-warning.vue'

  export default {
    components: {
      heatingTubeOvertemperature,
      heatingRelay,
      systemEarlyWarning
    },
    data () {
      return {
        navActive: 0,
        navList: [{
                    name: '加热管超温',
                    id: 0
                  },
                  {
                    name: '加热继电器',
                    id: 1
                  }, {
                    name: '系统预警',
                    id: 2
                  }
        ]
      }
    },
    computed: {
      style () {
        let transform = `transform:translateX(-${this.navActive * 387}px);`
        return `${transform}`
      }
    },
    methods: {
      clickNavItem (i) {
        this.navActive = i.id
      }
    }
  }
</script>

<style lang="less" scoped>
    .heating-system-warning-warp {
        width: 387px;

        .box {
            box-sizing: border-box;
            padding-top: 22px;
            height: 238px;
            background-image: url("/static/images/home/chart-bg.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            overflow: hidden;

            .nav {
                display: flex;
                align-items: center;
                margin-left: 73px;
                width: 299px;
                height: 32px;
                background-image: url("/static/images/home/heating-system-warning/nav-bg.png");
                background-size: 100%;
                background-repeat: no-repeat;
                background-position: center;

                .nav-item {
                    position: relative;
                    width: 33.33%;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    color: #74a0bf;
                    text-align: center;
                    cursor: pointer;

                    &::after {
                        position: absolute;
                        content: " ";
                        top: 50%;
                        margin-top: -6px;
                        right: 0;
                        width: 1px;
                        height: 13px;
                        opacity: 1;
                        background: #1d4a54;
                    }

                    &:last-child {
                         &::after {
                             display: none;
                         }
                    }

                    &.active {
                        background-image: url("/static/images/home/heating-system-warning/nav.png");
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        background-position: 0 8px;
                        color: #ffffff;
                    }
                }
            }

            .list-warp {
                display: flex;
                flex-wrap: nowrap;
                transition: 0.3s;

                .item {
                    flex-shrink: 0;
                    width: 100%;
                    height: 190px;
                }
            }
        }
    }
</style>
